/**
 * features/landing/frameCss.ts
 * ------------------------------------------------------------------
 * Styles for BrowserFrame, shared by every landing variant.
 *
 * Extracted from landingCss.ts because the editorial variant (LandingIndex)
 * renders the same component without that stylesheet — which left its
 * screenshots with no frame at all. One definition, injected by whoever uses
 * the component.
 * ------------------------------------------------------------------
 */
export const FRAME_CSS = `
/* ---- Browser frame ---- */
.ac-win {
  background:#fff; border-radius:14px; overflow:hidden;
  box-shadow:0 34px 80px -28px rgba(10,8,6,.62), 0 2px 10px rgba(10,8,6,.16);
  border:1px solid rgba(255,255,255,.10);
}
.ac-win-bar {
  display:flex; align-items:center; gap:12px; padding:10px 13px;
  background:#f4f2ef; border-bottom:1px solid rgba(0,0,0,.07);
}
.ac-win-dots i {
  width:9px; height:9px; border-radius:50%; background:#dcd8d3;
  display:inline-block; margin-right:5px;
}
.ac-win-url {
  flex:1; text-align:center; font-size:10.5px; font-weight:600; letter-spacing:.02em;
  color:#8b8f95; background:#fff; border-radius:999px;
  padding:4px 12px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}
.ac-win-screen { position:relative; aspect-ratio:16/10; background:#fbfaf9; }
.ac-win-screen img { width:100%; height:100%; object-fit:cover; object-position:top center; display:block; }
.ac-float { animation:ac-float 7.5s ease-in-out infinite; }
.ac-float2 { animation:ac-float 9s ease-in-out infinite reverse; }
@keyframes ac-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-11px)} }

/* Fallback mock screen */
.ac-mock { position:absolute; inset:0; display:grid; grid-template-columns:22% 1fr; background:#fbfaf9; }
.ac-mock-rail { background:#f4f2ef; border-right:1px solid rgba(0,0,0,.05); padding:9% 8%; display:flex; flex-direction:column; gap:9%; }
.ac-mock-brand { height:9px; border-radius:3px; background:var(--acc); opacity:.85; }
.ac-mock-nav { height:6px; border-radius:3px; background:rgba(0,0,0,.09); }
.ac-mock-nav.on { background:var(--acc); opacity:.55; }
.ac-mock-body { padding:7% 7%; display:flex; flex-direction:column; gap:7%; }
.ac-mock-kpis { display:grid; grid-template-columns:repeat(3,1fr); gap:6%; }
.ac-mock-kpi { background:#fff; border:1px solid rgba(0,0,0,.06); border-radius:7px; padding:8% 9%; display:flex; flex-direction:column; gap:6px; }
.ac-mock-kpi-l { height:4px; width:70%; border-radius:2px; background:rgba(0,0,0,.10); }
.ac-mock-kpi-v { height:9px; width:88%; border-radius:3px; background:var(--acc); opacity:.75; }
.ac-mock-kpi-v.alt { background:#16a34a; opacity:.6; }
.ac-mock-chart { flex:1; min-height:0; display:flex; align-items:flex-end; gap:5%; padding:0 2%; }
.ac-mock-chart span { flex:1; border-radius:3px 3px 0 0; background:var(--acc); opacity:.28; }
.ac-mock-chart span:nth-child(2) { opacity:.75; }
.ac-mock-rows { display:flex; flex-direction:column; gap:8px; }
.ac-mock-row { display:flex; justify-content:space-between; gap:12px; border-top:1px solid rgba(0,0,0,.05); padding-top:8px; }
.ac-mock-row span:first-child { height:5px; width:44%; border-radius:2px; background:rgba(0,0,0,.10); }
.ac-mock-row span:last-child { height:5px; width:18%; border-radius:2px; background:rgba(0,0,0,.16); }
`;
